// Mock data for Best Food Buddy app

export const foodPersonalities = {
  comfort: {
    title: "The Comfort Connoisseur",
    description: "You find joy in familiar flavors and cozy meals that warm the soul",
    traits: ["Loves home-cooked meals", "Prefers familiar flavors", "Values comfort over novelty", "Enjoys hearty portions"],
    foods: ["Mac & Cheese", "Chicken Noodle Soup", "Fresh Baked Bread", "Chocolate Chip Cookies", "Mashed Potatoes"],
    color: "from-amber-400 to-orange-500",
    icon: "heart",
    image: "https://images.unsplash.com/photo-1617024805970-1b717c0b8b2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjb21mb3J0JTIwZm9vZHxlbnwwfHx8fDE3NTY3MTg2NjB8MA&ixlib=rb-4.1.0&q=85"
  },
  adventurous: {
    title: "The Flavor Explorer",
    description: "You crave bold flavors and exotic cuisines from around the world",
    traits: ["Seeks new experiences", "Loves bold spices", "Enjoys cultural cuisine", "Open to unusual combinations"],
    foods: ["Thai Green Curry", "Moroccan Tagine", "Korean BBQ", "Sushi Omakase", "Ethiopian Injera"],
    color: "from-red-500 to-pink-500",
    icon: "globe",
    image: "https://images.unsplash.com/photo-1661939252817-ebb73304f4c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxleG90aWMlMjBjdWlzaW5lfGVufDB8fHx8MTc1NjcxODY2NHww&ixlib=rb-4.1.0&q=85"
  },
  healthy: {
    title: "The Wellness Warrior",
    description: "You prioritize nutrition and love fresh, wholesome ingredients",
    traits: ["Values nutrition", "Prefers fresh ingredients", "Conscious about health", "Enjoys natural flavors"],
    foods: ["Quinoa Buddha Bowl", "Grilled Salmon", "Avocado Toast", "Fresh Smoothie Bowls", "Mediterranean Salad"],
    color: "from-green-400 to-emerald-500",
    icon: "leaf",
    image: "https://images.unsplash.com/photo-1623452768745-de5f0d565c12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMGZvb2QlMjB2YXJpZXR5fGVufDB8fHx8MTc1NjcxODY1NHww&ixlib=rb-4.1.0&q=85"
  }
};

export const preferenceOptions = [
  {
    id: 'flavor',
    question: "Which flavor profile appeals to you most?",
    options: [
      { 
        id: 'mild', 
        label: 'Mild & Familiar', 
        image: 'https://images.unsplash.com/photo-1612376527389-355236f332b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxjb21mb3J0JTIwZm9vZHxlbnwwfHx8fDE3NTY3MTg2NjB8MA&ixlib=rb-4.1.0&q=85',
        personality: 'comfort' 
      },
      { 
        id: 'spicy', 
        label: 'Bold & Spicy', 
        image: 'https://images.unsplash.com/photo-1613634710886-62212b2af1b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxleG90aWMlMjBjdWlzaW5lfGVufDB8fHx8MTc1NjcxODY2NHww&ixlib=rb-4.1.0&q=85',
        personality: 'adventurous' 
      },
      { 
        id: 'fresh', 
        label: 'Fresh & Light', 
        image: 'https://images.unsplash.com/photo-1541855099555-42c6a7c57cfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjb2xvcmZ1bCUyMGZvb2QlMjB2YXJpZXR5fGVufDB8fHx8MTc1NjcxODY1NHww&ixlib=rb-4.1.0&q=85',
        personality: 'healthy' 
      }
    ]
  },
  {
    id: 'dining',
    question: "What's your ideal dining experience?",
    options: [
      { 
        id: 'cozy', 
        label: 'Cozy & Intimate', 
        image: 'https://images.unsplash.com/photo-1605926637412-b0cd5a3e3543?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxjb21mb3J0JTIwZm9vZHxlbnwwfHx8fDE3NTY3MTg2NjB8MA&ixlib=rb-4.1.0&q=85',
        personality: 'comfort' 
      },
      { 
        id: 'exotic', 
        label: 'Exotic & Adventurous', 
        image: 'https://images.unsplash.com/photo-1750271327963-281743a0cc30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxleG90aWMlMjBjdWlzaW5lfGVufDB8fHx8MTc1NjcxODY2NHww&ixlib=rb-4.1.0&q=85',
        personality: 'adventurous' 
      },
      { 
        id: 'fresh_natural', 
        label: 'Fresh & Natural', 
        image: 'https://images.unsplash.com/photo-1705475388190-775066fd69a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb2xvcmZ1bCUyMGZvb2QlMjB2YXJpZXR5fGVufDB8fHx8MTc1NjcxODY1NHww&ixlib=rb-4.1.0&q=85',
        personality: 'healthy' 
      }
    ]
  },
  {
    id: 'cooking',
    question: "How do you prefer to cook/eat?",
    options: [
      { 
        id: 'traditional', 
        label: 'Traditional Methods', 
        image: 'https://images.unsplash.com/photo-1614961908593-2c6bf2bdf2ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxjb21mb3J0JTIwZm9vZHxlbnwwfHx8fDE3NTY3MTg2NjB8MA&ixlib=rb-4.1.0&q=85',
        personality: 'comfort' 
      },
      { 
        id: 'experimental', 
        label: 'Experimental & Fusion', 
        image: 'https://images.unsplash.com/photo-1750271328082-22490577fbb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxleG90aWMlMjBjdWlzaW5lfGVufDB8fHx8MTc1NjcxODY2NHww&ixlib=rb-4.1.0&q=85',
        personality: 'adventurous' 
      },
      { 
        id: 'simple', 
        label: 'Simple & Clean', 
        image: 'https://images.pexels.com/photos/33713810/pexels-photo-33713810.jpeg',
        personality: 'healthy' 
      }
    ]
  }
];

// Mock saved results for localStorage
export const mockSavedResults = [
  {
    id: '1',
    personality: 'comfort',
    date: '2025-01-31',
    shared: true
  },
  {
    id: '2', 
    personality: 'adventurous',
    date: '2025-01-30',
    shared: false
  }
];